exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AppsDropdown__app_row--2VIqw {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  padding-top: 18px;\n  padding-bottom: 10px;\n  color: var(--gray-10) !important;\n  padding-left: 30px;\n  padding-top: 20px;\n  padding-bottom: 15px; }\n  .AppsDropdown__app_row--2VIqw:hover .AppsDropdown__app_title--1iL0s {\n    color: var(--blue-5); }\n\n.AppsDropdown__app_title--1iL0s {\n  display: flex;\n  align-items: center;\n  font-weight: 600; }\n  .AppsDropdown__app_title--1iL0s svg {\n    margin-right: 5px; }\n\n.AppsDropdown__app_description--EGt5U {\n  height: 45px;\n  width: 200px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 15px;\n  margin-top: 2px; }\n", ""]);

// exports
exports.locals = {
	"app_row": "AppsDropdown__app_row--2VIqw",
	"app_title": "AppsDropdown__app_title--1iL0s",
	"app_description": "AppsDropdown__app_description--EGt5U"
};